export default __webpack_public_path__ + "static/img-ei-4-444c5297d975e6ff53a39ef0ef4a084a.png";